// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .panel-selection {
  position: absolute;
  top: 35px;
  bottom: 0px;
  overflow: auto;
  width: calc(100% - 10px);
}
:host .section-item {
  width: 100%;
}
:host .section-item-block input, :host span, :host mat-select {
  width: calc(100% - 15px);
}
:host .item-device-tag {
  width: calc(100% - 5px);
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/panel/panel-property/panel-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/panel/panel-property/panel-property.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;ACAR;ADGI;EACI,WAAA;ACDR;ADII;EACI,wBAAA;ACFR;ADKI;EACI,uBAAA;ACHR","sourcesContent":[":host {\n    .panel-selection {\n        position: absolute;\n        top: 35px;\n        bottom: 0px;\n        overflow: auto;\n        width:calc(100% - 10px);\n    }\n\n    .section-item {\n        width: 100%;\n    }\n\n    .section-item-block input, span, mat-select {\n        width:calc(100% - 15px);\n    }\n\n    .item-device-tag {\n        width:calc(100% - 5px);\n    }\n}",":host .panel-selection {\n  position: absolute;\n  top: 35px;\n  bottom: 0px;\n  overflow: auto;\n  width: calc(100% - 10px);\n}\n:host .section-item {\n  width: 100%;\n}\n:host .section-item-block input, :host span, :host mat-select {\n  width: calc(100% - 15px);\n}\n:host .item-device-tag {\n  width: calc(100% - 5px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
